export const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : ''
